import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Col } from 'antd';
import CompanyDataCard, { CompanyDataRow } from 'components/reusable/CompanyDataCard';
import { ReactComponent as BasicInfoIcon } from 'assets/img/icons/cardIcons/basicInfo.svg';
import { summaryInformation } from 'store/entities/companySearchResult/selectors/unregisteredReportSelector';
import useNumberFormatter from 'hooks/format/useNumberFormatter';
import React from 'react';

const FinancialInfo = () => {
  const { t } = useTranslation();
  const formatCurrency = useNumberFormatter();
  const formatNumber = useNumberFormatter({ style: 'decimal' });
  const { summaryInformation: summaryInformationState } = useSelector(summaryInformation);

  const concatFinancialInfoRowValues = () => {
    const rows = [
      {
        type: t('companyResult.summary.income'),
        value: summaryInformationState?.income ? formatCurrency(summaryInformationState.income) : t('global.noEntries'),
      },
      {
        type: t('companyResult.summary.export'),
        value: summaryInformationState?.export?.exportAmount
          ? formatCurrency(summaryInformationState?.export?.exportAmount)
          : t('global.noEntries'),
      },
      {
        type: t('companyResult.summary.paidVmiTaxes'),
        value: summaryInformationState?.paidVmiTaxes?.amount
          ? formatCurrency(summaryInformationState.paidVmiTaxes.amount)
          : t('global.noEntries'),
      },
      {
        type: t('companyResult.summary.authorizedCapital'),
        value: summaryInformationState?.authorizedCapital?.amount
          ? `${formatNumber(summaryInformationState?.authorizedCapital?.amount)} ${
              summaryInformationState?.authorizedCapital?.currency
            }`
          : t('global.noEntries'),
      },
      {
        type: t('companyResult.summary.socialSecurityDebts'),
        value: summaryInformationState?.sodraDebts?.amount
          ? formatCurrency(summaryInformationState.sodraDebts.amount)
          : t('companyResult.summary.socialSecurityDebts.none'),
      },
      {
        type: t('companyResult.summary.averageWages'),
        value: summaryInformationState?.averageWage
          ? formatCurrency(summaryInformationState.averageWage)
          : t('global.noEntries'),
      },
    ];

    return rows.map(row => `${row.type} - ${row.value}`).join('\r\n');
  };

  return (
    <Col
      xs={{ span: 24, order: 1 }}
      sm={{ span: 24, order: 1 }}
      md={{ span: 24, order: 1 }}
      lg={{ span: 12, order: 1 }}
      xl={{ span: 12, order: 1 }}
      xxl={{ span: 12, order: 1 }}
      className="flex"
    >
      <CompanyDataCard
        title={t('companyResult.financialInfo.title')}
        icon={<BasicInfoIcon className="title-icon" />}
        copyData={concatFinancialInfoRowValues()}
      >
        <div>
          <CompanyDataRow
            halfBlock
            type={t('companyResult.summary.income')}
            value={
              summaryInformationState?.income ? formatCurrency(summaryInformationState.income) : t('global.noEntries')
            }
          />
          <CompanyDataRow
            halfBlock
            type={t('companyResult.summary.export')}
            value={
              summaryInformationState?.export?.exportAmount
                ? formatCurrency(summaryInformationState?.export?.exportAmount)
                : t('global.noEntries')
            }
          />
          <CompanyDataRow
            halfBlock
            type={t('companyResult.summary.paidVmiTaxes')}
            value={
              summaryInformationState?.paidVmiTaxes?.amount
                ? formatCurrency(summaryInformationState.paidVmiTaxes.amount)
                : t('global.noEntries')
            }
          />
          <CompanyDataRow
            halfBlock
            type={t('companyResult.summary.authorizedCapital')}
            value={
              summaryInformationState?.authorizedCapital?.amount
                ? `${formatNumber(summaryInformationState?.authorizedCapital?.amount)} ${
                    summaryInformationState?.authorizedCapital?.currency
                  }`
                : t('global.noEntries')
            }
          />
          <CompanyDataRow
            halfBlock
            type={t('companyResult.summary.socialSecurityDebts')}
            value={
              summaryInformationState?.sodraDebts?.amount
                ? formatCurrency(summaryInformationState.sodraDebts.amount)
                : t('companyResult.summary.socialSecurityDebts.none')
            }
          />
          <CompanyDataRow
            halfBlock
            type={t('companyResult.summary.averageWages')}
            value={
              summaryInformationState?.averageWage
                ? formatCurrency(summaryInformationState.averageWage)
                : t('global.noEntries')
            }
          />
        </div>
      </CompanyDataCard>
    </Col>
  );
};

export default FinancialInfo;
